import ReactCurrencyInput, { CurrencyInputProps } from 'react-currency-input-field';

import { CoreInput, CoreInputProps } from '../../cdl/Input/components/CoreInput';

export interface FormattedNumberInputProps extends CoreInputProps, CurrencyInputProps {}

export const FormattedNumberInput = (props: FormattedNumberInputProps) => {
    return <CoreInput {...props} as={ReactCurrencyInput} />;
};
